import Trinity from '@core/scripts/components/trinity-adapter.js';
import Device from '@core/scripts/components/device.js';


export const TrinityEvents = {
  sendClickServiceHome: (clickName) => {
    Trinity.sendTrinityEvent({
      schema: {
        version: 1,
        name: 'CLICK_SERVICE_HOME',
      },
      attributes: {
        clickName: clickName,
        object: 'button',
        page: 'service',
        isApp: Device.isApp(),
      },
    });
  },

  sendClickMyAccount: (clickName) => {
    Trinity.sendTrinityEvent({
      schema: {
        version: 1,
        name: 'CLICK_SERVICE_SELFSERVICE_MYACCOUNT',
      },
      attributes: {
        clickName: clickName,
        object: 'button',
        page: 'service',
        isApp: Device.isApp(),
      },
    });
  },

  sendClickContact: (clickName) => {
    Trinity.sendTrinityEvent({
      schema: {
        version: 1,
        name: 'CLICK_SERVICE_CONTACT',
      },
      attributes: {
        clickName: clickName,
        object: 'button',
        page: 'service',
        isApp: Device.isApp(),
      },
    });
  },

  sendClickServiceNavigation: (clickName) => {
    Trinity.sendTrinityEvent({
      schema: {
        version: 2,
        name: 'CLICK_SERVICE_NAVI',
      },
      attributes: {
        clickName: clickName,
        object: 'link',
        page: 'service',
        isApp: Device.isApp(),
      },
    });
  },

    sendClickReturn(clickName, question) {
        Trinity.sendTrinityEvent({
            schema: {
                version: 1,
                name: 'CLICK_SERVICE_RETURN'
            },
            attributes: {
                clickName: clickName,
                questionAboutReturn: question,
                object: 'button',
                page: 'service',
                isApp: Device.isApp()
            }
        });
    },

    sendClickNewsletter(clickName) {
        Trinity.sendTrinityEvent({
            schema: {
                version: 1,
                name: 'CLICK_SERVICE_NEWSLETTER'
            },
            attributes: {
                clickName: clickName,
                object: 'button',
                page: 'service',
                isApp: Device.isApp()
            }
        });

    },

    sendClickDelivery(clickName) {
        Trinity.sendTrinityEvent({
            schema: {
                version: 1,
                name: 'CLICK_SERVICE_DELIVERY_SHIPPINGCOSTS'
            },
            attributes: {
                clickName: clickName,
                object: 'button',
                page: 'service',
                isApp: Device.isApp()
            }
        });
    }

};
